import { render, staticRenderFns } from "./SendContractModal.vue?vue&type=template&id=385140cb&scoped=true&"
import script from "./SendContractModal.vue?vue&type=script&lang=js&"
export * from "./SendContractModal.vue?vue&type=script&lang=js&"
import style0 from "./SendContractModal.vue?vue&type=style&index=0&id=385140cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385140cb",
  null
  
)

export default component.exports